import { render, staticRenderFns } from "./wayTestA.vue?vue&type=template&id=72ca9d12&scoped=true&"
import script from "./wayTestA.vue?vue&type=script&lang=js&"
export * from "./wayTestA.vue?vue&type=script&lang=js&"
import style0 from "./wayTestA.vue?vue&type=style&index=0&id=72ca9d12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ca9d12",
  null
  
)

export default component.exports